import React from 'react';

function Precos(){
    return <section id="preco">


            <div className="row text-center">
                <div className="titulo">
                    <h1>Videos</h1>
                    <p></p>
                </div>
            </div>

            <div className="row text-center">
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header"><h4>Produtos sem lactose</h4></div>
                        <div className="card-body">
                            <iframe src="https://www.youtube.com/embed/Q-iXZPwvDSc"></iframe>
                        </div>
                    </div>
                </div>
                
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header"><h4>Receita</h4></div>
                        <div className="card-body">
                            <iframe src="https://www.youtube.com/embed/pCOydifkDcs"></iframe>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-header"><h4>Homenagem</h4></div>
                        <div className="card-body">
                            <iframe src="https://www.youtube.com/embed/0IYGEB1T6Ns"></iframe>
                        </div>
                    </div>
                </div>
          
                
              
        </div>
    </section>;
  }

export default Precos;

